import { usePbDispatch, usePbSelector } from '../../store/pbStoreHooks';
import React, { useEffect } from 'react';
import { RequestStatus } from '../../store/network/managedRequest';
import {
    GetOperationalContacts,
    OperationalContactRoles,
} from '../../store/operationalContactsSlice';
import useTranslate from '../useTranslate';
import LargeCard from '../main/large-card';
import useFeatureAccess from '../../util/useFeatureAccess';
import LinkButton from '../util/link-button';
import { Link } from 'react-router';
import { PbRequest } from '../../store/pbRequest';

function OperationalContactsListCard() {
    const strings = useTranslate('OperationalContactsList');
    const roleNames = useTranslate('OperationalContactRoleNames');
    const dispatch = usePbDispatch();
    const contactsRequest = usePbSelector(
        (state) => state.pbRequest[PbRequest.GET_OPERATIONAL_CONTACTS]
    );
    const contactsRequestData = usePbSelector(
        (state) => state.operationalContacts.operationalContacts
    );
    const selectedPartner = usePbSelector(
        (state) => state.partnerManager.selectedPartner
    );
    const { canWriteFeature } = useFeatureAccess(selectedPartner);

    useEffect(() => {
        if (contactsRequest.status === RequestStatus.PENDING) {
            return;
        }
        dispatch(GetOperationalContacts());
    }, []);

    const initialOrSuccess =
        contactsRequest.status === RequestStatus.INITIAL ||
        contactsRequest.status === RequestStatus.SUCCESS;
    const errorStatus = contactsRequest.status === RequestStatus.FAILURE;
    const showNoContactsMessage =
        initialOrSuccess && contactsRequestData?.list?.length === 0;
    const mayAddContact = canWriteFeature('GENERAL_OPERATIONAL_CONTACTS');

    return (
        <LargeCard title={strings.title}>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>{strings.columns.name}</th>
                        <th>{strings.columns.role}</th>
                        <th>{strings.columns.email}</th>
                        <th>{strings.columns.phone1}</th>
                        <th>{strings.columns.phone2}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {contactsRequest.status === RequestStatus.SUCCESS &&
                        contactsRequestData?.list
                            ?.toSorted(
                                (a, b) =>
                                    OperationalContactRoles.indexOf(a.role) -
                                    OperationalContactRoles.indexOf(b.role)
                            )
                            .map((contact) => (
                                <tr key={contact.operational_contact_id}>
                                    <td>
                                        {contact.first_name} {contact.name}
                                    </td>
                                    <td>{roleNames[contact.role]}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.phone1}</td>
                                    <td>{contact.phone2}</td>
                                    <td>
                                        <Link
                                            to={`/operational-contacts/${contact.operational_contact_id}`}
                                            className="icon icon-wew-button-enter icon-sm"
                                        />
                                    </td>
                                </tr>
                            ))}
                    {showNoContactsMessage && (
                        <tr>
                            <td colSpan={7}>{strings.noContacts}</td>
                        </tr>
                    )}
                    {errorStatus && (
                        <tr>
                            <td colSpan={7}>{strings.errorLoading}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {mayAddContact && (
                <LinkButton
                    text={strings.createContact}
                    to={'/operational-contacts/create'}
                    pullRight
                />
            )}
        </LargeCard>
    );
}

export default OperationalContactsListCard;
